export default [
  {
    path: 'consultas/premios',
    name: 'premios',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Jogos',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Consultas', link: 'consultas' },
        { name: 'Prêmios', },
      ]
    }
  },
]